import { Box, Typography } from '@mui/material'
import { type FC, type ReactNode } from 'react'
import { filterLabelSx } from 'recruiter/filterStyles'

interface FilterWrapperProps {
    label: string
    children: ReactNode
    headerActions?: ReactNode
}

export const FilterWrapper: FC<FilterWrapperProps> = ({
    label,
    children,
    headerActions,
}) => (
    <Box
        data-testid={`filter-label-${label.toLowerCase().replace(/\s+/g, '-')}`}
    >
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 0.5,
            }}
        >
            <Typography sx={filterLabelSx}>{label}</Typography>
            {headerActions}
        </Box>
        {children}
    </Box>
)
